<template>
  <div>
    <vxe-grid
      ref="orderTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      show-footer
      keep-source
      :editConfig="{ trigger: 'click', mode: 'column' }"
      :footer-method="() => footerData"
      @edit-closed="onEditClosed"
      row-id="shipmentPackingOrderCode"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
      @cell-click="onCellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import { add } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { default: () => {}, type: Object },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)
      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))
      const result = this.tableColumns.map((t) =>
        totalColumnValues[t.field]
          ? totalColumnValues[t.field].toLocaleString()
          : ''
      )
      result[0] = '合计'
      return [result]
    },
  },
  methods: {
    async onEditClosed({ row, column }) {
      if (!row) return
      if (!this.$refs.orderTable.isUpdateByRow(row, column.property)) return
      const { shipmentPackingOrderCode, customsBillNo } = row
      const params = {
        listOrderCode: [shipmentPackingOrderCode],
        customsBillNo,
      }
      const res = await this.$api
        .shipmentPackingOrderUpdateApi(params)
        .catch(() => null)
      const { status } = res || {}
      if (status != 200) {
        this.$message.error('更新海关编号失败')
        return
      }
      this.$emit('reload')
    },
    onCheckboxChange({ records }) {
      this.$emit('checkboxChange', records)
    },
    onCellClick({ row, column }) {
      if (this.disabled) return
      const { property } = column
      const filterColumns = ['checkbox', 'customsBillNo']
      if (filterColumns.includes(property)) return
      this.$refs.orderTable.toggleCheckboxRow(row)

      const data = this.$refs.orderTable.getCheckboxRecords(true)
      this.$emit('checkboxChange', data)
    },
    clearCheckboxRow() {
      this.$refs.orderTable.clearCheckboxRow()
      this.$refs.orderTable.clearCheckboxReserve()
    },
  },
}
</script>
